import React from "react";
import errorImg from "assets/images/icons/errors/404.svg";
import "./index.css";

export default () => (
  <main className="error-page container-fluid text-center" data-flex="column m-center x-center">
    <div className="error-icon mb-6">
      <img src={errorImg} alt="404" />
    </div>
    <h1 className="error-numbered">404</h1>
    <p>Sorry, page not found</p>
    <a href="/">Take me back please</a>
  </main>
);
